import { api } from "./api";
import type { RequestBody } from "./spec";

/**
 * A Domain request: an unauthenticated ask to add an email domain to the allowed
 * list. The institution name and account type are hints for the Operator, and the
 * requester is not notified of the outcome (stringr CONTEXT.md, Domain request).
 */
export type DomainRequestReq = RequestBody<"domains/request", "post">;

const domainsService = {
  /**
   * Public: no bearer. Refuses with a 400 when the domain is already supported or
   * already has a request.
   */
  requestDomain: (body: DomainRequestReq) => api.post("domains/request", { body }),
};

export default domainsService;
